import type { SVGProps } from 'react';

const SvgNoteBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M10.5 9.5C9.94772 9.5 9.5 9.94772 9.5 10.5C9.5 11.0523 9.94772 11.5 10.5 11.5V10.5V9.5ZM16.5 11.5C17.0523 11.5 17.5 11.0523 17.5 10.5C17.5 9.94771 17.0523 9.5 16.5 9.5V10.5V11.5ZM10.5 12.5C9.94772 12.5 9.5 12.9477 9.5 13.5C9.5 14.0523 9.94772 14.5 10.5 14.5V13.5V12.5ZM16.5 14.5C17.0523 14.5 17.5 14.0523 17.5 13.5C17.5 12.9477 17.0523 12.5 16.5 12.5V13.5V14.5ZM5 4V5H19V4V3H5V4ZM20 5H19V19H20H21V5H20ZM19 20V19H5V20V21H19V20ZM4 19H5V5H4H3V19H4ZM5 20V19H4H3C3 20.1046 3.89543 21 5 21V20ZM20 19H19V20V21C20.1046 21 21 20.1046 21 19H20ZM19 4V5H20H21C21 3.89543 20.1046 3 19 3V4ZM5 4V3C3.89543 3 3 3.89543 3 5H4H5V4ZM7.5 4H6.5V20H7.5H8.5V4H7.5ZM10.5 10.5V11.5L16.5 11.5V10.5V9.5L10.5 9.5V10.5ZM10.5 13.5V14.5H16.5V13.5V12.5H10.5V13.5Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgNoteBd;
